<template>
  <q-dialog v-model="currentVisible" persistent style="width: 300px;">
    <q-card>
      <q-card-section class="column items-center">
        <q-avatar size="md">
          <span class="text-xxl warning-color">
            <Icon name="error_outline" material />
          </span>
        </q-avatar>
        <span class="q-ml-sm" style="text-align: center;"
          >{{ $t('You are tyring to reset password for a subuser') }}
        </span>

        <input
          placeholder="Please enter your username"
          type="text"
          v-model="inputSubuserUsername"
          @keyup="inputKey()"
          style="width: 90%;
          margin-top: 20px; padding: 10px;"
        />
        <span class="text-2 text-danger" style="margin-top: 5px;" v-if="error">{{
          $t('This username does not exist.')
        }}</span>
      </q-card-section>
      <q-card-actions align="right">
        <Button flat :label="$t('Cancel')" color="standard" @click="handleCancel" />
        <Button
          flat
          :label="$t('Proceed')"
          :loading="loading"
          color="primary"
          @click="handleSubmit"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import Icon from '@/components/uikit/Icon';
import Button from '@/components/uikit/CButton/index';

const messages = {
  en: {
    'This username does not exist.': 'This username does not exist.',
    'You are tyring to reset password for a subuser':
      'You are tyring to reset password for a subuser. Input username instead.',
    Cancel: 'Cancel',
    Proceed: 'Proceed',
  },
  ja: {
    'This username does not exist.': 'このユーザー名は存在しません。',
    'You are tyring to reset password for a subuser':
      'パスワードを変更するサブユーザーのログインIDを入力してください。',
    Cancel: 'キャンセル',
    Proceed: '実行する',
  },
};

export default {
  name: 'ConfirmDialog',
  components: { Icon, Button },
  i18n: { messages },
  props: {
    // Support .sync
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: 'warning',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentVisible: {
      set() {
        this.$emit('update:visible', this.visible);
      },
      get() {
        return this.visible;
      },
    },
  },
  data() {
    return {
      inputSubuserUsername: '',
    };
  },
  methods: {
    handleSubmit() {
      this.$emit('submit');
      console.log('submit', this.loading);
    },
    handleCancel() {
      this.inputSubuserUsername = '';
      this.$emit('updateField', '');
      this.$emit('cancel');
    },
    inputKey() {
      this.$emit('updateField', this.inputSubuserUsername);
    },
  },
};
</script>

<style scoped></style>
